import { Login, User } from "@/api/interface/index";
import { PORT1 } from "@/api/config/servicePort";
import DynamicRouter from "@/assets/json/dynamicRouter.json";
import http from "@/api";

/**
 * @name 登录模块
 */
// * 用户登录接口
export const loginApi = (params: Login.ReqLoginForm) => {
	// return http.post<Login.ResLogin>(PORT1 + `/login`, params, { headers: { noLoading: true } }); // 正常 post json 请求  ==>  application/json
	// return http.post<Login.ResLogin>(PORT1 + `/login`, {}, { params }); // post 请求携带 query 参数  ==>  ?username=admin&password=123456
	// return http.post<Login.ResLogin>(PORT1 + `/login`, qs.stringify(params)); // post 请求携带 表单 参数  ==>  application/x-www-form-urlencoded
	return http.post<Login.ResLogin>(PORT1 + `/login`, params, { headers: { noLoading: true } }); // 控制当前请求不显示 loading
};

// 用户退出登录接口
export const loginOut = (params?: Login.ReqLoginForm) => {
	return http.post<Login.ResLogin>(PORT1 + `/loginout`, params, { headers: { noLoading: true } });
};

// * 获取按钮权限
export const getAuthButtonListApi = () => {
	return http.get<Login.ResAuthButtons>(PORT1 + `/auth/buttons`, {}, { headers: { noLoading: true } });
};

// * 获取菜单列表
export const getAuthMenuListApi = () => {
	// return http.get<Menu.MenuOptions[]>(PORT1 + `/menu/list`, {}, { headers: { noLoading: true } });
	// 如果想让菜单变为本地数据，注释上一行代码，并引入本地 dynamicRouter.json 数据
	return DynamicRouter;
};

// * 获取用户信息 & 菜单
export const getUserInfoApi = () => {
	return http.get<User.ResUserInfo>(PORT1 + "/getuserinfo", {}, { headers: { noLoading: true } });
};

// 更新密码
export const updateMyPwd = (params: any) => {
	return http.post(PORT1 + "/upmypwd", params, { headers: { noLoading: true } });
};

// 自动登录
export const autoLogin = (params: any) => {
	return http.get<Login.ResLogin>(PORT1 + "/autologin?token=" + params.token, {}, { headers: { noLoading: false } });
};
